import React from "react";
import { NumericFormat } from 'react-number-format';
import { getAffiliationColor, getOverride } from "../helpers";

import { ReactComponent as IncumbentIcon } from "../images/icon-incumbent.svg";

/**
 * Displays a single candidate in a race.
 */
const HeadCardCandidate = ({ options, candidate, votesCast, shouldShowImages, thereIsAnIncumbent, thereIsAWinner }) => {
  const radius = 15.91549430918954;
  const posX = 51;
  const posY = 51;
  const strokeWidth = 60;

  const name = getOverride(candidate, "name");
  const votes = getOverride(candidate, "votes");
  const incumbent = getOverride(candidate, "incumbent");
  const winner = getOverride(candidate, "winner");
  const party = (options.showParty && getOverride(candidate, "party")) || "";

  const percentOfVotes = candidate.percentage_override || (votesCast > 0 ? ((votes / votesCast) * 100) : 0);

  return (
    <div className={`widget candidate ${party.toLowerCase()}${((thereIsAWinner && winner) ? " winner" : "")}${((thereIsAWinner && !winner) ? " loser" : "")}`}>
      <div className="candidate-name">
      {thereIsAnIncumbent && incumbent && (
          <div className="candidate-name-incumbent">
            <IncumbentIcon alt="Incumbent" className="incumbent-icon" />
          </div>
        )}
        <div>
          <a
            href={candidate.website}
            target="_blank"
            rel="noopener noreferrer"
          >
            {name}
          </a>
          {options.showParty && party && (
            <div className="candidate-affiliation">{party.toLowerCase()}</div>
          )}
        </div>
      </div>
      <div className="svg-container">
        <svg width="100%" height="100%" viewBox="0 0 100 100" className="donut" preserveAspectRatio="xMinYMin meet">
          <defs>
            <pattern id={candidate.name.replace(/\W+/g, "").toLowerCase()} x="0%" y="0%" height="100%" width="100%" viewBox="0 0 512 512">
              <image x="0%" y="0%" width="512" height="512" xlinkHref={candidate.image}></image>
            </pattern>
          </defs>

          <circle
            className="progressBarCircular-bar"
            strokeDasharray="440"
            r={radius}
            cx={posX}
            cy={posY}
            fill="none"
            strokeWidth={strokeWidth}
            stroke={getAffiliationColor(party || "")} // Doesn't use override.
            pathLength="100"
          />
          {options.showPercentOfVotes && (
            <circle
              className="progressBarCircular-bar-background"
              strokeDasharray="100 0"
              r={radius}
              cx={posX}
              cy={posY}
              fill="none"
              strokeWidth={strokeWidth}
              stroke="#ccc"
            />
          )}
          <circle
            className={"progressBarCircular-bar" +
            (percentOfVotes !== 0 ? "" : " no-circle-stroke")}
            strokeDasharray={`${percentOfVotes} ${100 - percentOfVotes}`}
            r={radius}
            cx={posX}
            cy={posY}
            fill="none"
            strokeWidth={strokeWidth}
            stroke={getAffiliationColor(party || "")} // Doesn't use override.
            pathLength="100"
          />
          <circle
            className="progressBarCircular-image-background"
            r="30"
            cx={posX}
            cy={posY}
            strokeWidth="1"
            stroke="none"
            fill = "#fff"
          />
          {(options.showImages && shouldShowImages) && (
            <circle
              className="progressBarCircular-image"
              r="30"
              cx={posX}
              cy={posY}
              strokeWidth="1"
              stroke="#fff"
              fill = {`url(#${candidate.name.replace(/\W+/g, "").toLowerCase()})`}
            />
          )}
          {options.showPercentOfVotes && (
            <g 
              className={"chart-text" +
              (options.showPercentOfVotesDecimal ? " show-percent-decimal" : "")}>
              <text x="50%" y="50%" className="chart-number">
                {options.showPercentOfVotesDecimal ? percentOfVotes.toFixed(1) : percentOfVotes.toFixed(0)}%
              </text>
              <text x="46.5%" y="92%" className="chart-number ie11">
                {options.showPercentOfVotesDecimal ? percentOfVotes.toFixed(1) : percentOfVotes.toFixed(0)}%
              </text>
            </g>
          )}
        </svg>
      </div>

      {options.showVotes && (
        <div className="candidate-total-votes"><NumericFormat value={votes} displayType={'text'} thousandSeparator={true} /></div>
      )}
    </div>
  );
};

export default HeadCardCandidate;
